<template>
  <button
    v-if="clickable"
    type="button"
    :class="['failure-icon', 'failure-icon-' + type, 'failure-icon-button']"
    :title="text"
    :aria-label="text"
    @click.stop="$emit('click')"
  >
    <i :class="iconClass" aria-hidden="true"></i>
  </button>
  <span v-else :class="['failure-icon', 'failure-icon-' + type]" :title="text" role="img" :aria-label="text">
    <i :class="iconClass" aria-hidden="true"></i>
  </span>
</template>

<script>
// The one visual language of the failures of an efficiency test, everywhere: an exclamation mark, red for a
// problem that needs a change (blocking), amber for one that may not come back (transient). The arrows are
// not used here: they are the "execute again" command of the row, next to it. The text is the tooltip. In the list it is a button that opens the reasons.
import { FAILURE_TYPES } from '../../utils/failurePresentation'

export default {
  props: {
    type: {
      type: String,
      default: FAILURE_TYPES.TRANSIENT,
    },
    // The tooltip, already translated.
    text: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    iconClass() {
      return 'fas fa-exclamation-circle'
    },
  },
}
</script>

<style lang="scss" scoped>
.failure-icon {
  display: inline-block;
  margin-left: 0.375rem;
  line-height: 1;
}
.failure-icon-button {
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.failure-icon-blocking {
  color: rgb(192, 67, 42);
}
.failure-icon-transient {
  color: rgb(224, 150, 0);
}
</style>
